export default __webpack_public_path__ + "static/media/curriculum.56837ec2.png";